import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'reactstrap';
import { BASE_URL, API } from 'CONST';
import { get } from 'helpers/requests';
import { GARANTIA_WRITE } from 'helpers/profilePermission';
import {
  cellDateOperation,
  cellDobleRowOperation,
  cellNumOperation,
  cellOperation,
  headerOperation,
} from 'helpers/tables';
import { apelable } from 'helpers/helpers';
import isUserHasProfile from 'helpers/profileValidator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye, faGavel } from '@fortawesome/free-solid-svg-icons';
import useTableFilters from 'helpers/useTableFilters';
import FilterSelect from '../shared/FilterSelect';
import PageContainer from '../PageContainer';
import BaseTable from '../UI/BaseTable';

const OportunidadesList = () => {
  const [onFilteredChange, onFetchData, loading, data] = useTableFilters(
    `${BASE_URL}${API.oportunidadesLinea}`,
  );
  const NO_FILTERED_ID = -1;

  const [tiposEstado, setTiposEstado] = useState([]);

  useEffect(() => {
    get(`${BASE_URL}${API.estadosOportunidad}`).then((response) => {
      setTiposEstado(response.results);
    });
  }, []);

  const columns = [
    {
      Header: () => headerOperation('Afianzado'),
      id: 'afianzado',
      accessor: (i) => cellDobleRowOperation(i.afianzado.rut, i.afianzado.nombre),
      sortable: false,
    },
    {
      Header: () => headerOperation('Monto de Línea (UF)'),
      id: 'monto',
      accessor: (i) => (i.monto ? cellNumOperation(i.monto) : cellOperation('-', 'right')),
      sortable: true,
      filterable: false,
    },
    {
      Header: () => headerOperation('Estado'),
      id: 'estado',
      accessor: (i) => cellOperation(i.estado.descripcion),
      Filter: (obj) => (
        <FilterSelect
          filter={obj.filter}
          onFilterChange={obj.onChange}
          options={tiposEstado.map((elem) => ({ label: elem.descripcion, value: elem.id }))}
          defaultOption={{ label: 'Todos', value: NO_FILTERED_ID }}
        />
      ),
      minWidth: 150,
      sortable: true,
    },
    {
      Header: () => headerOperation('Fecha de Creación'),
      id: 'creacion_ts',
      accessor: (i) => cellDateOperation(i.creacion_ts),
      sortable: true,
      filterable: false,
    },
    {
      Header: () => headerOperation('Fecha de modificación'),
      id: 'actualizacion_ts',
      accessor: (i) => cellDateOperation(i.actualizacion_ts),
      sortable: true,
      filterable: false,
    },
    {
      Header: () => headerOperation('Acciones'),
      id: 'acciones',
      accessor: 'id',
      Cell: (row) => {
        if (isUserHasProfile(GARANTIA_WRITE)) {
          return cellOperation(
            <Link to={`/garantia/oportunidades/${row.value}`} className="table-link">
              {/* Si está en curso */}
              {row.original.estado.nemotecnico !== 'rechazado' &&
                row.original.estado.nemotecnico !== 'emitida' && <FontAwesomeIcon icon={faEdit} />}
              {/* Si es apelable */}
              {row.original.estado.nemotecnico === 'rechazado' &&
                (apelable(row.original.fecha_rechazo) && !row.original.cliente_acepta_rechazo) && (
                  <FontAwesomeIcon icon={faGavel} />
                )}
              {/* Si está rechazada y no es apelable, o está emitida */}
              {((row.original.estado.nemotecnico === 'rechazado' &&
                (!apelable(row.original.fecha_rechazo) || row.original.cliente_acepta_rechazo)) ||
                row.original.estado.nemotecnico === 'emitida') && <FontAwesomeIcon icon={faEye} />}
            </Link>,
          );
        }
        return <div />;
      },
      sortable: false,
      filterable: false,
    },
  ];

  return (
    <PageContainer
      breadcrumbs={[
        { id: 0, name: 'RIESGO', url: '/' },
        { id: 1, name: 'GARANTÍA', url: '/' },
        { id: 2, name: 'OPORTUNIDADES' },
      ]}
    >
      <div className="table-container">
        <Col className="button-container d-flex justify-content-end pr-0">
          {isUserHasProfile(GARANTIA_WRITE) && (
            <Link
              className="btn btn-secondary blue"
              disabled={false}
              to="/garantia/oportunidades/create"
            >
              Crear oportunidad
            </Link>
          )}
        </Col>
        <BaseTable
          columns={columns}
          data={data.data}
          loading={loading}
          filterable
          resizable={false}
          onFetchData={onFetchData}
          onFilteredChange={onFilteredChange}
          pages={data.pages}
          resultCount={data.count}
          showPagination
          style={{ height: '63vh' }}
        />
      </div>
    </PageContainer>
  );
};

export default OportunidadesList;
